package one.healthium.ui.compose.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.Stable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.SubcomposeLayout
import one.healthium.ui.compose.theme.AppTheme

@Composable
fun AppScaffold(
    modifier: Modifier = Modifier,
    scaffoldState: AppScaffoldState = rememberAppScaffoldState(),
    topBar: @Composable () -> Unit = {},
    backgroundColor: Color = AppTheme.colors.windowBackground,
    content: @Composable (PaddingValues) -> Unit
) {
    Box(
        modifier = modifier.fillMaxSize().background(backgroundColor),
    ) {
        SubcomposeLayout { constraints ->
            val layoutWidth = constraints.maxWidth
            val layoutHeight = constraints.maxHeight

            val looseConstraints = constraints.copy(minWidth = 0, minHeight = 0)

            layout(layoutWidth, layoutHeight) {
                val topBarPlaceables = subcompose(AppScaffoldContent.TopBar, topBar).map {
                    it.measure(looseConstraints)
                }

                val topBarHeight = topBarPlaceables.maxByOrNull { it.height }?.height ?: 0

                val bodyContentPlaceables = subcompose(AppScaffoldContent.MainContent) {
                    content(PaddingValues(top = topBarHeight.toDp()))
                }.map { it.measure(looseConstraints) }

                bodyContentPlaceables.forEach {
                    it.place(0, 0)
                }
                topBarPlaceables.forEach {
                    it.place(0, 0)
                }
            }
        }
    }
}

@Stable
class AppScaffoldState()

@Composable
fun rememberAppScaffoldState(
): AppScaffoldState {
    return remember {
        AppScaffoldState()
    }
}

private enum class AppScaffoldContent { TopBar, MainContent }
